import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { type Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { shareReplayCold } from '@principle-theorem/shared';

@Component({
  selector: 'pr-history-list-item',
  templateUrl: './history-list-item.component.html',
  styleUrls: ['./history-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HistoryListItemComponent {
  @Input() first = false;
  @Input() last = false;
  @Input() selected = false;
  @Input() closed = true;

  isAboveSmall$: Observable<boolean>;

  constructor(breakpointObserver: BreakpointObserver) {
    this.isAboveSmall$ = breakpointObserver
      .observe(['(min-width: 960px)'])
      .pipe(
        map((result: BreakpointState) => result.matches),
        shareReplayCold()
      );
  }
}
